import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-0" }
const _hoisted_3 = { class: "d-flex row justify-content-center align-items-center flex-wrap gap-2 p-4" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-lg-3 col-sm-6" }
const _hoisted_6 = { class: "form-group mb-4" }
const _hoisted_7 = { class: "col-lg-4 col-sm-6 text-end mt-4" }
const _hoisted_8 = { class: "d-inline-flex flex-wrap gap-3 justify-content-end" }
const _hoisted_9 = { class: "default-table-area style-two default-table-width" }
const _hoisted_10 = { class: "table-responsive" }
const _hoisted_11 = { class: "table align-middle" }
const _hoisted_12 = { class: "text-body" }
const _hoisted_13 = { class: "text-body" }
const _hoisted_14 = { class: "text-center" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = ["onClick"]
const _hoisted_17 = {
  id: "mdlPlayActions",
  class: "modal fade",
  tabindex: "-1",
  "aria-labelledby": "mdlPlayActionsLabel",
  "aria-hidden": "true",
  size: "large"
}
const _hoisted_18 = { class: "modal-dialog modal-xl" }
const _hoisted_19 = { class: "modal-content" }
const _hoisted_20 = { class: "modal-header" }
const _hoisted_21 = {
  class: "modal-title fs-5",
  id: "mdlPlayActionsLabel"
}
const _hoisted_22 = { class: "modal-body" }
const _hoisted_23 = { class: "default-table-area style-two default-table-width" }
const _hoisted_24 = { class: "table-responsive" }
const _hoisted_25 = { class: "table align-middle" }
const _hoisted_26 = { class: "text-body text-right" }
const _hoisted_27 = { class: "text-body" }
const _hoisted_28 = ["innerHTML", "title"]
const _hoisted_29 = { class: "text-body text-center" }
const _hoisted_30 = { class: "text-body text-right" }
const _hoisted_31 = { class: "text-center" }
const _hoisted_32 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OverlayLoader = _resolveComponent("OverlayLoader")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_draggable = _resolveComponent("draggable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_OverlayLoader, { visible: _ctx.isLoading }, null, 8 /* PROPS */, ["visible"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("form", {
            class: "position-relative table-src-form me-0",
            onSubmit: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _cache[5] || (_cache[5] = _createElementVNode("label", { class: "label text-secondary" }, "Nombre", -1 /* HOISTED */)),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filters.name) = $event)),
                    class: "form-control h-55",
                    placeholder: "Ingrese nombre"
                  }, null, 512 /* NEED_PATCH */), [
                    [_vModelText, _ctx.filters.name]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.getPlaysRepository()), ["prevent"])),
                    class: "btn btn-outline-primary py-1 px-3 fw-medium fs-14 hover-bg"
                  }, " Buscar "),
                  _createVNode(_component_RouterLink, { to: "/repository/create" }, {
                    default: _withCtx(() => _cache[6] || (_cache[6] = [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-primary py-1 px-3 fw-medium fs-14 rounded-3 hover-bg"
                      }, [
                        _createElementVNode("span", { class: "py-sm-1 d-block" }, [
                          _createElementVNode("span", null, "Agregar Jugada")
                        ])
                      ], -1 /* HOISTED */)
                    ])),
                    _: 1 /* STABLE */
                  })
                ])
              ])
            ])
          ], 32 /* NEED_HYDRATION */)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("table", _hoisted_11, [
              _cache[8] || (_cache[8] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", { scope: "col" }, "#"),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-center"
                  }, "Nombre de Jugada"),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-center"
                  }, "Nro. Acciones"),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-center"
                  }, [
                    _createTextVNode("Creado"),
                    _createElementVNode("br"),
                    _createTextVNode(" por")
                  ]),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-center"
                  }, [
                    _createTextVNode("Fecha "),
                    _createElementVNode("br"),
                    _createTextVNode("creación")
                  ]),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-center"
                  }, "Opciones")
                ])
              ], -1 /* HOISTED */)),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: item.id
                  }, [
                    _createElementVNode("td", null, _toDisplayString((index + 1)), 1 /* TEXT */),
                    _createElementVNode("td", null, _toDisplayString(item.playName), 1 /* TEXT */),
                    _createElementVNode("td", null, _toDisplayString(item.items.length), 1 /* TEXT */),
                    _createElementVNode("td", _hoisted_12, _toDisplayString(item.createdBy), 1 /* TEXT */),
                    _createElementVNode("td", _hoisted_13, _toDisplayString(item.createdAtDateTimeString), 1 /* TEXT */),
                    _createElementVNode("td", _hoisted_14, [
                      _createVNode(_component_RouterLink, {
                        to: `/repository/create/${item.id}`
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("button", {
                            class: "ps-2 border-0 bg-transparent lh-1 position-relative",
                            disabled: item.matchId != null
                          }, [
                            _createElementVNode("i", {
                              class: _normalizeClass(["material-symbols-outlined fs-16 ps-2", {'text-default' : item.matchId != null, 'text-primary' : item.matchId == null}])
                            }, " settings ", 2 /* CLASS */)
                          ], 8 /* PROPS */, _hoisted_15)
                        ]),
                        _: 2 /* DYNAMIC */
                      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"]),
                      _createElementVNode("button", {
                        class: "border-0 bg-transparent lh-1 position-relative",
                        onClick: ($event: any) => (_ctx.playActionsModal(item.id))
                      }, [...(_cache[7] || (_cache[7] = [
                        _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-primary" }, " lists ", -1 /* HOISTED */)
                      ]))], 8 /* PROPS */, _hoisted_16)
                    ])
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ])
            ])
          ])
        ])
      ])
    ]),
    _createCommentVNode(" Modal "),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("h1", _hoisted_21, " Jugada " + _toDisplayString(_ctx.play.playName) + " - Acciones ", 1 /* TEXT */),
            _cache[9] || (_cache[9] = _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            }, null, -1 /* HOISTED */))
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("table", _hoisted_25, [
                  _cache[13] || (_cache[13] = _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", {
                        scope: "col",
                        class: "text-center"
                      }),
                      _createElementVNode("th", {
                        scope: "col",
                        class: "text-center"
                      }, "Orden"),
                      _createElementVNode("th", {
                        scope: "col",
                        class: "text-center"
                      }, "Tipo"),
                      _createElementVNode("th", {
                        scope: "col",
                        class: "text-center"
                      }, "Detalle"),
                      _createElementVNode("th", {
                        scope: "col",
                        class: "text-center"
                      }, "Tipo de Pregunta"),
                      _createElementVNode("th", {
                        scope: "col",
                        class: "text-center"
                      }, "Nro. Opciones"),
                      _createElementVNode("th", {
                        scope: "col",
                        class: "text-center"
                      }, "Opciones")
                    ])
                  ], -1 /* HOISTED */)),
                  (_ctx.playItems.length)
                    ? (_openBlock(), _createBlock(_component_draggable, {
                        key: 0,
                        modelValue: _ctx.playItems,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.playItems) = $event)),
                        "item-key": "id",
                        tag: "tbody",
                        handle: ".drag-handle",
                        animation: 200,
                        onEnd: _ctx.updateOrderItems
                      }, {
                        item: _withCtx(({ element: item }) => [
                          (_openBlock(), _createElementBlock("tr", {
                            key: item.id
                          }, [
                            _cache[12] || (_cache[12] = _createElementVNode("td", { class: "text-body text-right drag-handle" }, [
                              _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-primary cursor-move" }, "drag_indicator")
                            ], -1 /* HOISTED */)),
                            _createElementVNode("td", _hoisted_26, _toDisplayString(item.order), 1 /* TEXT */),
                            _createElementVNode("td", _hoisted_27, _toDisplayString(item.playType), 1 /* TEXT */),
                            _createElementVNode("td", {
                              innerHTML: _ctx.limitHtmlContent(item.description),
                              title: _ctx.stripHtmlAndLimit(item.description)
                            }, null, 8 /* PROPS */, _hoisted_28),
                            _createElementVNode("td", _hoisted_29, _toDisplayString(item.questionType ?? '-'), 1 /* TEXT */),
                            _createElementVNode("td", _hoisted_30, _toDisplayString(item.totalOptions ?? '-'), 1 /* TEXT */),
                            _createElementVNode("td", _hoisted_31, [
                              _createVNode(_component_RouterLink, {
                                to: `/repository/${item.playTypeId == _ctx.PLAY_TYPES.QUIZ ? 'question' : 'content'}/edit/${item.id}`,
                                onClick: _cache[3] || (_cache[3] = ($event: any) => {_ctx.modalPlayActions.hide();})
                              }, {
                                default: _withCtx(() => _cache[10] || (_cache[10] = [
                                  _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-primary" }, " edit ", -1 /* HOISTED */)
                                ])),
                                _: 2 /* DYNAMIC */
                              }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"]),
                              _createElementVNode("button", {
                                class: "ps-2 border-0 bg-transparent lh-1 position-relative",
                                onClick: ($event: any) => (_ctx.removedPlay(item.playTypeId, item.id))
                              }, _cache[11] || (_cache[11] = [
                                _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-primary" }, "delete", -1 /* HOISTED */)
                              ]), 8 /* PROPS */, _hoisted_32)
                            ])
                          ]))
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["modelValue", "onEnd"]))
                    : _createCommentVNode("v-if", true)
                ])
              ]),
              _cache[14] || (_cache[14] = _createElementVNode("div", { class: "p-4 pt-lg-4" }, null, -1 /* HOISTED */))
            ])
          ]),
          _cache[15] || (_cache[15] = _createElementVNode("div", { class: "modal-footer" }, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-danger text-white",
              "data-bs-dismiss": "modal"
            }, " Cerrar ")
          ], -1 /* HOISTED */))
        ])
      ])
    ])
  ], 64 /* STABLE_FRAGMENT */))
}